module.exports = __webpack_public_path__ + "media/social/tiktok-icon-2e4ccd54.svg";